'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodashInflection = require('lodash-inflection');

var _lodashInflection2 = _interopRequireDefault(_lodashInflection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

_lodash2.default.mixin(_lodashInflection2.default);

var SimpleGroup = function SimpleGroup(_ref) {
  var tenants = _ref.tenants,
      selectedTenant = _ref.selectedTenant,
      resourceType = _ref.resourceType,
      label = _ref.label,
      onSelectTenant = _ref.onSelectTenant;
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'h4',
      null,
      (0, _lodash2.default)(label).pluralize(tenants.length).toString()
    ),
    _react2.default.createElement(
      'div',
      { className: 'list-group' },
      tenants.map(function (t) {
        return (
          /* TODO: tenant logo */
          /* eslint-disable jsx-a11y/no-static-element-interactions */
          _react2.default.createElement(
            'a',
            {
              key: t.value,
              className: 'clickable list-group-item ' + (t.value === selectedTenant ? 'active' : ''),
              onClick: function onClick() {
                return onSelectTenant({ value: t.value, label: t.label, resourceType: resourceType });
              } },
            t.label
          )
        );
      })
    )
  );
};

SimpleGroup.propTypes = {
  tenants: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired
  })).isRequired,
  selectedTenant: _propTypes2.default.string,
  resourceType: _propTypes2.default.string.isRequired,
  onSelectTenant: _propTypes2.default.func.isRequired,
  label: _propTypes2.default.string.isRequired
};

SimpleGroup.defaultProps = {
  selectedTenant: undefined
};

var SimpleSelect = function SimpleSelect(_ref2) {
  var merchants = _ref2.merchants,
      fulfillers = _ref2.fulfillers,
      props = _objectWithoutProperties(_ref2, ['merchants', 'fulfillers']);

  return _react2.default.createElement(
    'div',
    null,
    merchants.length ? _react2.default.createElement(SimpleGroup, _extends({}, props, { tenants: merchants, resourceType: 'merchant', label: 'Merchant' })) : null,
    fulfillers.length ? _react2.default.createElement(SimpleGroup, _extends({}, props, { tenants: fulfillers, resourceType: 'fulfiller', label: 'Fulfiller' })) : null
  );
};

SimpleSelect.propTypes = {
  merchants: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired
  })).isRequired,
  fulfillers: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired
  })).isRequired
};

exports.default = SimpleSelect;
//# sourceMappingURL=SimpleSelect.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cimpress-technology/react-platform-tenant-selector/lib/components/tenant/SimpleSelect.js
// module id = 562
// module chunks = 0